<!--
 * @Author: 肖槿
 * @Date: 2020-06-16 15:52:40
 * @Description: 订单管理搜索组件
 * @LastEditors: 肖槿
 * @LastEditTime: 2020-07-02 17:52:36
 * @FilePath: \s2b-admin\src\components\admin\shop\order-management-search.vue
-->
<template>
  <div>
    <a-form layout="inline" :form="form" @submit="handleFormSubmit">
      <div class="filter-condition-form">
        <a-form-item label="商家名称：">
          <a-input
            v-model="queryParams.merchant_name"
            allowClear
            placeholder="请输入商家名称"
            style="width:190px;"
          />
        </a-form-item>
        <a-form-item label="订单编号：">
          <a-input
            v-model="queryParams.xd_parent_order_id"
            allowClear
            placeholder="请输入订单编号"
            style="width:190px;"
          />
        </a-form-item>
        <a-form-item label="商品编码：">
          <a-input
            v-model="queryParams.out_spu_id"
            allowClear
            placeholder="请输入商品编码"
            style="width:190px;"
            @blur="onlyNumber($event, 'out_spu_id')"
          />
        </a-form-item>
        <a-form-item label="商品名称：">
          <a-input
            v-model="queryParams.spu_name"
            allowClear
            placeholder="请输入商品名称"
            style="width:190px;"
          />
        </a-form-item>
        <a-form-item label="商品类目：">
          <div id="cctv" style="position:relative;">
            <a-cascader
              style="width:250px;"
              :load-data="loadData"
              v-model="category_id"
              :options="categoryList"
              :fieldNames="fieldNames"
              placeholder="一级类目名称 > 二级类目名称 > 三级类目名称"
              @change="onChange"
              :getPopupContainer="positionContainer"
            />
          </div>
        </a-form-item>
        <a-form-item label="下单时间：">
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            v-model="queryParams.create"
            style="width:190px;"
          />
        </a-form-item>
        <a-form-item label="完成时间：">
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            v-model="queryParams.finish"
            style="width:190px;"
          />
        </a-form-item>
        <a-form-item label="结算状态：">
          <a-select
            v-model="queryParams.settlement_status"
            placeholder="全部"
            allowClear
            style="width:190px;"
          >
            <a-select-option v-for="(item, k) in Settlement" :key="k" :value="item.value">{{
              item.label
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="收货人姓名：">
          <a-input
            v-model="queryParams.receiver_name"
            allowClear
            placeholder="请输入收货人姓名"
            style="width:190px;"
          />
        </a-form-item>
        <a-form-item label="收货人手机：">
          <a-input
            :maxLength="11"
            v-model="queryParams.receiver_phone"
            allowClear
            placeholder="请输入收货人手机"
            style="width:190px;"
            @blur="onlyPhone($event, 'receiver_phone')"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit" :loading="loading" style="margin-right:20px;"
            >查询</a-button
          >
          <a-button :loading="loading" @click="formReset">重置</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import { AuditResult, Brand, Settlement } from '@/const/shop';
import shopMixin from './shopMixin';

export default {
  mixins: [shopMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: String,
      default: '1',
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      AuditResult,
      Brand,
      Settlement,
      category_id: [],
      fieldNames: {
        label: 'name',
        value: 'id',
        children: 'children',
        isLeaf: 'cat_level',
      },
    };
  },
  methods: {
    loadData(selectedOptions) {
      this.$emit('loadData', selectedOptions);
    },
    onChange(v) {
      this.queryParams.category_id = v.length === 3 ? v[2] : undefined;
    },
    formReset() {
      this.form.resetFields();
      this.category_id = [];
      this.queryParams.page = 1;
      this.queryParams.page_size = 10;
      this.queryParams = this.form.getFieldsValue();
      this.$emit('success', this.queryParams);
    },
  },
};
</script>

<style lang="less" scoped>
.filter-condition-form {
  margin-bottom: 20px;
}
</style>
